export default function navigateToExternalUrl(url: string) {
  window.location.href = url;
}